import { useContext } from 'react';
import * as Sentry from '@sentry/react';
import { useQuery } from 'react-query';
import { FilterContext } from '../context/FilterContext';
import { skipSentry } from '../helpers/helpers';
import { ApiContext } from '../context/ApiContext';

const useFiltersFetchedData = <T>(cacheKey: string, endpoint: string, sentryMsg: string) => {
  const { apiFetch } = useContext(ApiContext);
  const { paginationModel } = useContext(FilterContext);

  const createSearchString = (searchParamsObj: Record<string, unknown>) => {
    const searchParams = new URLSearchParams();
    Object.entries(searchParamsObj).forEach(([key, value]) => {
      searchParams.set(key, value.toString());
    });
    return searchParams.toString();
  };

  const {
    refetch: fetchData,
    data,
    isLoading,
    isError,
    error,
    isRefetching,
  } = useQuery<T>(
    [cacheKey, '', {}, paginationModel.pageSize, paginationModel.page + 1],
    () => {
      const searchString = createSearchString({
        getItems: 'valid',
        page: paginationModel.page + 1,
        limit: paginationModel.pageSize,
      });

      return apiFetch(`${endpoint}?${searchString}`);
    },
    {
      onError(err: any) {
        if (err?.code === 401) return;
        if (!skipSentry(err)) {
          Sentry.captureException(new Error(`Error fetching ${sentryMsg}`), {
            extra: { error: JSON.stringify(err) },
          });
        }
      },
    }
  );

  return {
    fetchData,
    data,
    isLoading,
    isError,
    error,
    isRefetching,
  };
};

export default useFiltersFetchedData;
